import { ErpSidebarAppRail } from "./ErpSidebarAppRail";
import { RAIL_WIDTH } from "./ErpSidebar";
import { designTokens } from "@/config/design-tokens";

/**
 * Fixed app rail — always visible on desktop, regardless of page/iframe.
 * Renders at MainLayout level (AppShell) so it persists across all routes.
 */
export function AppRailFixed() {
  return (
    <div
      className="fixed z-30 overflow-hidden flex flex-col"
      style={{
        width: `${RAIL_WIDTH}px`,
        top: 0,
        left: 0,
        bottom: 0,
        background: "#ffffff",
        borderRight: designTokens.borders.sidebar,
      }}
    >
      <div className="flex-1 min-h-0 overflow-hidden">
        <ErpSidebarAppRail />
      </div>
    </div>
  );
}
